const DEFAULT_ADVICE = 'обратитесь в техподдержку';

export default {
  DEFAULT: `Произошла неизвестная ошибка. Обновите страницу и выполните действие заново или ${DEFAULT_ADVICE}`,

  1027: 'Аккаунт с данным email уже существует в системе',
};
